// Reporting one of Luna's messages (Google Play's rule for generative-AI
// apps: offensive output can be flagged without leaving the app). The
// "Bildir" button under her reply (components/ChatMessage.jsx) opens
// components/ReportDialog.jsx; lib/api.js reportMessage sends it.

// The reasons, in the dialog's order; `key` is what the server stores.
export const REPORT_CATEGORIES = [
  { key: "offensive", tr: "Rahatsız edici", en: "Offensive" },
  { key: "harmful", tr: "Zararlı", en: "Harmful" },
  { key: "inaccurate", tr: "Yanlış bilgi", en: "Inaccurate" },
  { key: "other", tr: "Diğer", en: "Other" },
];

export const REPORT_NOTE_MAX = 500;

// A message id the server gave (a MongoDB ObjectId).
const SERVER_ID = /^[a-f0-9]{24}$/i;

// Whether a message on screen gets the "Bildir" button: Luna's own and
// finished — not the greeting the app shows on its own (pages/Luna.jsx
// buildWelcomeMessage), which no model wrote and the server never kept.
// It also needs something to find it by: a server id, or text to match in
// the reloaded history (an HD call's card-only turn has neither).
export function canReport(msg) {
  if (!msg || msg.role !== "luna" || msg.streaming) return false;
  if (String(msg.id || "").startsWith("welcome-")) return false;
  return Boolean(serverMessageId(msg) || (typeof msg.text === "string" && msg.text.trim()));
}

// The server's id of a message on screen: the one its turn came back with
// (msg.messageId), or a reloaded message's own id (lib/api.js fetchMessages).
// null when the screen never learned it — a turn said in an HD call (the
// server stores those itself) — see findInHistory.
export function serverMessageId(msg) {
  const given = msg && msg.messageId != null ? String(msg.messageId) : "";
  if (SERVER_ID.test(given)) return given;
  const own = msg && msg.id != null ? String(msg.id) : "";
  return SERVER_ID.test(own) ? own : null;
}

// The id of Luna's latest message with this one's text in a reloaded
// transcript (lib/api.js fetchMessages: oldest first), or null.
export function findInHistory(msg, history) {
  const text = typeof msg?.text === "string" ? msg.text.trim() : "";
  if (!text || !Array.isArray(history)) return null;
  for (let i = history.length - 1; i >= 0; i--) {
    const m = history[i];
    if (m?.role === "luna" && typeof m.text === "string" && m.text.trim() === text) return serverMessageId(m);
  }
  return null;
}
